const Button = ({
  type = "button",
  onClick,
  variant = "primary",
  size = "md",
  btncls = "",
  text,
  children,
  customColor,
  ...rest
}) => {
  const className = `btn btn-${variant} btn-${size} ${btncls}`.trim();
 
  return (
    <button type={type} className={className} onClick={onClick} {...rest}>
      {children || text}
    </button>
  );
};
 
export default Button;